<script>
    import Recommendation from "./Recommendation.svelte";
    import LazyLoad from "vanilla-lazyload";
    import { getContext, onMount, setContext } from "svelte";
    import { generateRandomId } from "../utils/IdentifierGenerator";
    import scrollTracker from "../tracking/scrollTracker";
    import { calculateTileDimension } from "../utils/tileDimensionCalculator";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension";
    import { key as featureStateCtxKey } from "../context/featureState";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule";
    import { key as svgImageUrlPrefixCtxKey } from "../context/svgImageUrlPrefix";
    import { emitMiniActionEvent } from "../tracking/eventEmitter.js";
    import viewTracker from "../tracking/viewTracker.js";
    import CinemaFilterChips from "./CinemaFilterChips.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        headline = null,
        recommendations,
        tracking,
        featureIndex,
        cinemaIndex = null,
        cinemaMeta,
        additionalClickTracking,
        performance,
        site,
        sourceVariationId = undefined,
        cinemaInjectionContainerWidth,
        featuresState = {},
        wishlist_class = false,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        bottomPadding = 24,
        contentDresonRule = null,
        showTopInfo = false,
        trackingEventMergeId = null,
        loadedTrackingActionName = null,
        openedCallback = null,
        cinemaFilters = [],
        removeFilterCallBack,
        noRecommendationsFoundWithSellerFilters = false,
    } = $props();

    const { width, height } = calculateTileDimension(cinemaInjectionContainerWidth);
    const top = `${height / 2}px`;
    let enableSellerChipFilter = $state(
        featuresState &&
            featuresState.ENABLE_VENDOR_CHIPS_FILTER &&
            ((cinemaFilters && cinemaFilters.length === 1) || noRecommendationsFoundWithSellerFilters)
    );

    setContext(cinemaTileDimensionCtxKey, {
        width,
        height,
    });

    setContext(featureStateCtxKey, featuresState);
    setContext(contentDresonRuleCtxKey, contentDresonRule);

    const svgImageUrlPrefix = getContext(svgImageUrlPrefixCtxKey);

    const lazyLoadConfig = {
        unobserve_entered: true,
        threshold: 0,
        callback_loaded: (el) => {
            el.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
        },
        callback_error: (el) => {
            el.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
        },
    };

    const cinemaId = `reco_cinema__${generateRandomId(16)}`;
    let visibilityPreviousActionAlreadyTracked = false;
    let tileList = $state();
    let observerTracking;
    let verticalScrollAlreadyTracked = false;

    const trackView = (currentSlides) => {
        const firstSlideIndex = currentSlides[0];
        const firstExcludedSlideIndex = currentSlides[currentSlides.length - 1] + 2; /*                                                                         */
        const recommendationsTracking = recommendations
            .slice(firstSlideIndex, firstExcludedSlideIndex)
            .map((recommendation) => recommendation.tracking);
        if (!openedCallback) {
            viewTracker(
                tracking,
                recommendationsTracking,
                featureIndex,
                cinemaIndex,
                trackingEventMergeId,
                additionalTrackingLabels,
                loadedTrackingActionName
            );
        }
        openedCallback?.(currentSlides);
    };

    const trackVisibilityVerticalScroll = (tilesFeatureIds) => {
        const { id: cinemaFeatureId } = tracking;
        const featureIds = [cinemaFeatureId, ...tilesFeatureIds];
        emitMiniActionEvent(featureIds);
        verticalScrollAlreadyTracked = true;
    };

    const trackVisibilityHorizontalScroll = (direction, tilesFeatureIds = []) => {
        const visibleRecos = recommendations.filter((reco) => tilesFeatureIds.includes(reco.tracking?.id));
        const recommendationsTracking = visibleRecos.map(({ tracking }) => tracking);
        const recommendationsMeta = visibleRecos.map(({ meta }) => meta);
        scrollTracker(
            tracking,
            recommendationsTracking,
            featureIndex,
            cinemaIndex,
            direction,
            cinemaMeta,
            recommendationsMeta,
            sourceVariationId,
            additionalTrackingLabels
        );
    };

    const handleIntersectTracking = (entries) => {
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);
        if (!visibleEntries.length) {
            return;
        }
        const tilesFeatureIds = visibleEntries.map(
            ({
                target: {
                    dataset: { trackingFeatureId },
                },
            }) => trackingFeatureId
        );
        if (!verticalScrollAlreadyTracked) {
            trackVisibilityVerticalScroll(tilesFeatureIds);
        } else {
            trackVisibilityHorizontalScroll("next", tilesFeatureIds);
        }
        visibleEntries.forEach((entity) => observerTracking.unobserve(entity.target));
    };

    const lazyLoadImages = () => {
        if ("loading" in HTMLImageElement.prototype) {
            const images = document.querySelectorAll(".reco_cinema__image .lazy");
            images.forEach((img) => {
                img.parentElement.nextElementSibling.firstElementChild.classList.remove("p_loader250");
                img.src = img.dataset.src;
            });
        } else {
            const images = document.querySelectorAll(".reco_cinema__image .lazy");
            const lazyLoader = new LazyLoad(lazyLoadConfig, images);
            lazyLoader.update();
        }
    };

    const initializeTracking = (currentSlides) => {
        trackView(currentSlides);
        observerTracking = new IntersectionObserver(handleIntersectTracking);
        if (tileList) {
            [...tileList.children].forEach((tile) => observerTracking.observe(tile));
        }
    };

    onMount(() => {
        lazyLoadImages();
        window.o_global.eventQBus.on("pattern.carousel.mounted", ({ element, currentSlides }) => {
            if (!element.classList.contains(cinemaId)) {
                return;
            }
            performance.cinemaLoaded(site);
            initializeTracking(currentSlides);
        });
        window.o_global.eventQBus.emit("pattern.carousel.init", `.${cinemaId}`);
        window.o_global.eventQBus.on("pattern.carousel.stage.changed", ({ element, scrollingRight }) => {
            if (!element.classList.contains(cinemaId)) {
                return;
            }

            if (scrollingRight || visibilityPreviousActionAlreadyTracked) {
                return;
            }
            trackVisibilityHorizontalScroll("previous");
            visibilityPreviousActionAlreadyTracked = true;
        });
    });

    const removeFilter = (filter) => {
        enableSellerChipFilter = false;
        removeFilterCallBack(filter);
    };
</script>

<div class="reco_cinema {site}" style="--bottomPadding: {bottomPadding}">
    {#if headline !== null}
        <h2 class="reco_cinema__headline oc-headline-100 oc-headline-200--l">{headline}</h2>
    {/if}
    {#if enableSellerChipFilter}
        <CinemaFilterChips
            filters={cinemaFilters}
            removeFilterCallBack={removeFilter}
            {noRecommendationsFoundWithSellerFilters}
        />
    {/if}
    <div class="js_pl_carousel pl_carousel {cinemaId}" data-carousel-no-page-indicator data-carousel-mode="cinema">
        <ul class="reco_cinema__tiles pl_carousel__stage" bind:this={tileList}>
            {#each recommendations as recommendation, i}
                <Recommendation
                    {recommendation}
                    lazyLoad={i > 4}
                    cinemaTracking={tracking}
                    {featureIndex}
                    {cinemaIndex}
                    additionalCinemaClickTracking={additionalClickTracking}
                    {cinemaMeta}
                    {featuresState}
                    {cinemaId}
                    {additionalNextPiTrackingLabels}
                    {additionalTrackingLabels}
                    {wishlist_class}
                    {showTopInfo}
                />
            {/each}
        </ul>
        <!-- svelte-ignore a11y_consider_explicit_label -->
        <button style:top type="button" class="pl_carousel__arrow pl_rounded50">
            <svg class="pl_icon" role="img" data-testid="scroll-left">
                <use
                    href="{svgImageUrlPrefix}/assets-static/icons/pl_icon_arrow-left.svg#pl_icon_arrow-left"
                    xlink:href="{svgImageUrlPrefix}/assets-static/icons/pl_icon_arrow-left.svg#pl_icon_arrow-left"
                ></use>
            </svg>
        </button>
        <!-- svelte-ignore a11y_consider_explicit_label -->
        <button style:top type="button" class="pl_carousel__arrow pl_rounded50 pl_carousel__arrow--next">
            <svg class="pl_icon" role="img" data-testid="scroll-right">
                <use
                    href="{svgImageUrlPrefix}/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"
                    xlink:href="{svgImageUrlPrefix}/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"
                ></use>
            </svg>
        </button>
    </div>
</div>

<style lang="scss">
    .reco_cinema {
        height: 100%;
        width: 100%;
        background-color: transparent;
        line-height: normal;
        padding: 16px 0 calc(var(--bottomPadding) * 1px);
    }

    .reco_cinema__headline {
        padding-bottom: 16px;
        margin-left: 16px;
    }

    .reco_cinema__tiles {
        height: 100%;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        font-size: 0; /*                     */
        word-spacing: 0;
    }

    .reco_basketLayer {
        padding: 0;
    }
</style>
